const ACTION_TYPES = require('constants/actionTypes/beautyPreferences');

const initialState = {
    beautyPreferences: {
        skinTone: '',
        skinConcerns: [],
        ageRange: '',
        skinType: '',
        hairConcerns: [],
        hairDescrible: [],
        hairColor: '',
        eyeColor: '',
        fragrancePreferences: [],
        shoppingPreferences: [],
        ingredientPreferences: [],
        colorIQ: []
        // favoriteBrands: [],
    },
    expandedPreference: 'skinType',
    profileCompletionPercentage: 0,
    mappedBrandsList: null
};

const setColorIQ = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            colorIQ: [action.payload.colorIQ, ...state.beautyPreferences.colorIQ]
        }
    };
};

const setInitialBeautyPreferences = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            ...action.initialData
        },
        profileCompletionPercentage: action.profileCompletionPercentage
    };
};

const setMultiplePreferences = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            [action.category]: action.selectedProfiles
        }
    };
};

const clearPreference = (state, action) => {
    return {
        ...state,
        beautyPreferences: {
            ...state.beautyPreferences,
            [action.category]: []
        }
    };
};

const setExpandedPreference = (state, action) => {
    return {
        ...state,
        expandedPreference: action.expandedPreference
    };
};

const setProfileCompletionPercentage = (state, action) => {
    return {
        ...state,
        profileCompletionPercentage: action.profileCompletionPercentage
    };
};

const setMappedBrandsList = (state, action) => {
    return {
        ...state,
        mappedBrandsList: action.payload.mappedBrandsList
    };
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_INITIAL_BEAUTY_PREFERENCES:
            return setInitialBeautyPreferences(state, action);
        case ACTION_TYPES.SET_MULTIPLE_BEAUTY_PREFERENCES:
            return setMultiplePreferences(state, action);
        case ACTION_TYPES.CLEAR_BEAUTY_PREFERENCE:
            return clearPreference(state, action);
        case ACTION_TYPES.SET_COLOR_IQ:
            return setColorIQ(state, action);
        case ACTION_TYPES.SET_EXPANDED_PREFERENCE:
            return setExpandedPreference(state, action);
        case ACTION_TYPES.SET_PROFILE_COMPLETION_PERCENTAGE:
            return setProfileCompletionPercentage(state, action);
        case ACTION_TYPES.SET_MAPPED_BRANDS_LIST:
            return setMappedBrandsList(state, action);
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
